module.exports = __webpack_public_path__ + "img/bed-empty.e8b56b51.svg";